import { useIntl } from "react-intl";

import TabsContent from "@/components/adg4/tabs-content/src/tabs-content";
import { useLocalizedHref } from "@/libraries/web-framework";
import { DataEventProps } from "@/libraries/wpl/foundations/src";

const MarketingTabContent = () => {
    const intl = useIntl();

    const cardCtaText = intl.formatMessage({
        id: "HomePageTemplateV2.tab.marketing.card.linkText",
        defaultMessage: "Try it out"
    });

    const cardDataEventProps: DataEventProps = {
        "data-product-key": "home",
        "data-event-component": "linkButton",
        "data-event-container": "cardSection",
        "data-event": "clicked",
        "data-label": cardCtaText,
        "data-label-english": "Try it out"
    };

    const cardOneCtaUrl = useLocalizedHref(
        "/software/confluence/templates/customer-journey-mapping"
    );
    const cardTwoCtaUrl = useLocalizedHref(
        "/software/jira/templates/content-management"
    );
    const cardThreeCtaUrl = useLocalizedHref(
        "/software/jira/templates/campaign-management"
    );

    return (
        <TabsContent
            className="homepage-tabs-content"
            contentList={[
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.marketing.header",
                        defaultMessage: "Bring marketing closer to product"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.marketing.bodytext",
                        defaultMessage:
                            "Track your work easily, run cross-functional marketing projects, and remove silos so you deliver real impact."
                    })
                }
            ]}
            contentLink={{
                linkText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.marketing.learnMore",
                    defaultMessage: "Learn more about Marketing"
                }),
                link: useLocalizedHref("/teams/marketing"),
                linkLabel: "Learn more about Marketing",
                productKey: "home"
            }}
            pictureProps={{
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7s5rkhku1iv78na0b7w80720ycm373xi.webp",
                    alt: "",
                    height: 800,
                    width: 1536
                }
            }}
            tabContentEyebrowText={intl.formatMessage({
                id: "HomePageTemplateV2.tab.marketing.resources",
                defaultMessage: "Get started with a template"
            })}
            cardsContent={[
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.marketing.card1.headerText",
                        defaultMessage: "Customer journey mapping"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.marketing.card1.bodyText",
                        defaultMessage:
                            "Visualize how customers experience your product or service"
                    }),
                    ctaProps: {
                        text: cardCtaText,
                        href: cardOneCtaUrl,
                        dataEventProps: cardDataEventProps
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-card-1.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                },
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.marketing.card2.headerText",
                        defaultMessage: "Content management"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.marketing.card2.bodyText",
                        defaultMessage:
                            "Oversee your marketing content lifecycle from draft to delivery"
                    }),
                    ctaProps: {
                        text: cardCtaText,
                        href: cardTwoCtaUrl,
                        dataEventProps: cardDataEventProps
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-card-2.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                },
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.marketing.card3.headerText",
                        defaultMessage: "Campaign management"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.marketing.card3.bodyText",
                        defaultMessage:
                            "Track tasks and deadlines while managing end-to-end campaigns"
                    }),
                    ctaProps: {
                        text: cardCtaText,
                        href: cardThreeCtaUrl,
                        dataEventProps: cardDataEventProps
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-card-3.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                }
            ]}
        />
    );
};

export { MarketingTabContent };
